import AuthorityRegistrationModule from '../../modules/authority-registration-module';

class Main {
	constructor() {
        this.metaDescription = document.getElementById('meta-description');
        this.authorityRegistrationModule = new AuthorityRegistrationModule();
	}

	run() {
        if (!!this.metaDescription) {
            document.title = 'Registrierung für Behörden - anabin: Infoportal zu ausländischen Bildungsabschlüssen';
            this.metaDescription.setAttribute('content', 'Registrieren Sie sich als Behörde oder anerkannte deutsche Hochschule für den Zugang zur anabin BehördenVersion.');
        }
	}

	initializeModules() {

	}
}
const main = new Main();
main.run();


